import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { PriceRow, TextRow, TextToolTip } from 'components';
import { CustomDeleteModal } from 'fragments';
import { Images, SaveParams, useModal } from 'utils';
import { analyticActions } from 'store';
import { DataTypes, ValueFormatter, ValueTypes } from '../constants';
import { RenderWidgetImage } from './constnats';

const DELETE_ACTION_TYPE = 'DELETE_USER_KPI';

export const WidgetCard = ({ item, snapshot }) => {
  const { open } = useModal();
  const dispatch = useDispatch();
  const history = useHistory();
  const info = history?.location?.state;
  const [currentId, setCurrentId] = useState(null);

  const pushChart = () => {
    if (info?.activeChart?.id !== item?.id) {
      const params = {
        ...info,
        chartType: item?.chartTypes[0],
      };
      params.activeChart = item;
      SaveParams(history, params);
    }
  };

  const resetChart = () => {
    const params = {
      ...info,
    };
    delete params.activeChart;
    delete params.chartType;
    SaveParams(history, params);
  };

  return (
    <div
      style={{
        border: info?.activeChart?.id === item?.id ? '2px solid #0C66E4' : '1px solid #F2F4F7',
        zIndex: snapshot?.isDraggingOver ? 2001 : 1,
        transform: +snapshot?.draggingOverWith === +item?.id ? 'rotate(5deg)' : 'rotate(0)',
        transition: 'transform 0.2s ease',
      }}
      className={`widget-card-box`}
      onClick={pushChart}
      onMouseEnter={() => currentId !== item?.id && setCurrentId(item?.id)}
      onMouseLeave={() => setCurrentId(null)}
    >
      <div className='widget-card-info'>
        <div className='delete-widget'>
          <TextToolTip
            text={
              <button>
                {(currentId === item?.id || +snapshot?.draggingOverWith === +item?.id) &&
                  <img
                    className={`drag-indicator-img ${snapshot?.isDraggingOver ? 'drag-indicator-blue-img' : ''}`}
                    src={Images.dragIndicator}
                    alt='icon'
                  />
                }
              </button>
            }
            content='Drag Widget'
            wrapperStyles={
              {
                width: '18px',
                height: '18px',
              }
            }
            showTooltip
          />
          <button
            style={{marginRight:'-10px', marginTop: '1px'}}
            onClick={(e) => {
              e.stopPropagation();
              open(
                <CustomDeleteModal
                  cancelButton={'Remove'}
                  text={`Remove ${item?.name} Widget!`}
                  modalText={`Are you sure you want to remove this ${item?.name} widget? You can add it back anytime.`}
                  handleDel={() => dispatch(analyticActions.deleteUserKpi(item?.id))}
                  afterSuccess={resetChart}
                  actionType={DELETE_ACTION_TYPE}
                />);
            }}>
            <img src={Images.closeBtn} alt='close' />
          </button>
        </div>
        <div className='widget-card-icon-name-box'>
          <img className='widget-card-icon' src={RenderWidgetImage(item?.category)} alt='category' />
          <TextRow name={item?.name} textWidth={5} />
        </div>
      </div>


      <div className='widget-card-rate-box'>
        <p className='rate'>
          {item?.valueFormat === ValueTypes.DOLLAR ?
            <PriceRow info={item?.value} textWidth={7} />
            :
            ValueFormatter(item?.value, item?.valueFormat)
          }
        </p>

        {item?.type === DataTypes.PERIODIC && !!item?.comparison &&
          (item?.comparison > 0 ?
              <div className='plus-percentage'>
                <img src={Images.trendUp} alt='trendUp' />
                <p>{`+${item?.comparison?.toFixed(2)}%`} </p>
              </div>
              :
              <div className='minuse-percentage'>
                <img src={Images.trendDown} alt='trendDown' />
                <p>{`${item?.comparison?.toFixed(2)}%`} </p>
              </div>
          )
        }
      </div>
    </div>
  );
};
